import { prop, compose } from 'ramda';

import { success } from 'app/features/success/selectors';

const offlineViewingBlock = compose(prop('offlineViewingBlock'), success);
const isVisible = compose(prop('isVisible'), offlineViewingBlock);

export { isVisible };
